/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ServiceTypeEnum } from './serviceTypeEnum';
import { EnforcementCategoryEnum } from './enforcementCategoryEnum';
import { EnforcementTypeSelection } from './enforcementTypeSelection';
import { EnforcementStateEnum } from './enforcementStateEnum';


export interface EnforcementStatusPostSpec { 
    org_id?: string;
    service_type?: ServiceTypeEnum;
    enforcement_type?: EnforcementTypeSelection;
    current_state?: EnforcementStateEnum;
    scheduled_next_state?: EnforcementStateEnum;
    scheduled_next_enforcement_category?: EnforcementCategoryEnum;
    is_paused?: boolean;
    state_entered_ts?: Date;
    next_action_ts?: Date;
    pause_end_ts?: any | null;
}
export namespace EnforcementStatusPostSpec {
}


